module.exports = __webpack_public_path__ + "static/media/login_background.e69a724e.jpg";